import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLayout from './components/AdminLayout/AdminLayout';
import Login from './pages/Login/Login';
import Dashboard from './pages/Dashboard/Dashboard';
import Users from './pages/Users/Users';
import Listings from './pages/Listings/Listings';
import Orders from './pages/Orders/Orders';
import Points from './pages/Points/Points';
import Support from './pages/Support/Support';
import Coupon from './pages/Coupon/Coupon';
import Promotions from './pages/Promotions/Promotions';
import Affiliates from './pages/Affiliates/Affiliates';
import Payouts from './pages/Payouts/Payouts';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Login />} />

        <Route element={<AdminLayout />}>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/listings" element={<Listings />} />
          <Route path="/orders" element={<Orders />} />
          <Route path="/payouts" element={<Payouts />} />
          <Route path="/points" element={<Points />} />
          <Route path="/coupon" element={<Coupon />} />
          <Route path="/promotions" element={<Promotions />} />
          <Route path="/affiliates" element={<Affiliates />} />
          <Route path="/support" element={<Support />} />
        </Route>

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
